/**
 * 아바타.
 * 사진이 없으면 이름 앞 두 글자를 쓰고, 배경색은 id 해시로 고정 배정합니다.
 * 같은 사람은 언제 어느 화면에서 보든 같은 색이어야 합니다.
 */

const PALETTE = [
  '#4A5798',
  '#6E7CA8',
  '#7E6E9E',
  '#58748C',
  '#8A6E86',
  '#5F7F7A',
  '#86765C',
] as const;

export function avatarColor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

interface Props {
  name: string;
  seed?: string;
  /** 모임은 사각, 사람은 원 */
  square?: boolean;
}

export function Avatar({ name, seed, square }: Props) {
  const initials = name.slice(0, 2);
  return (
    <div
      className={square ? 'avatar avatar--square' : 'avatar'}
      style={{ background: avatarColor(seed ?? name) }}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
